






















import Vue from 'vue'
import SubjectTitle from '../atoms/SubjectTitle.vue'
import BaseButton from '../atoms/BaseButton.vue'

export default Vue.extend({
  components: {
    SubjectTitle,
    BaseButton
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    contents: {
      type: Object,
      required: true
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    yearDate() {
      const today = new Date(this.$store.state.currentDate)
      return String(today.getMonth() + 1 > 3 ? today.getFullYear() : today.getFullYear() - 1)
    },
    releasedContents() {
      const allContents = Object.entries(this.contents)
      if (this.showAll) {
        return allContents
      }
      const now = new Date().toISOString()
      return allContents.filter(
        ([, data]) => (data as { release_time: string | null }).release_time !== null && (data as { release_time: string | null }).release_time! <= now
      )
    }
  },
  methods: {
    getMonth(month: string) {
      return parseInt(month.slice(4))
    },
    getYear(month: string){
      return this.getMonth(month) > 3 ? parseInt(month.slice(0, 4)): parseInt(month.slice(0, 4)) - 1
    },
    moveMonth(month: string) {
      this.$store.commit('SET_MONTH', { month: this.getMonth(month) })
      this.$store.commit('SET_YEAR', { year: parseInt(month.slice(0, 4)) })
    }
  }
})
